import {Form, Formik} from 'formik'
import React from 'react'
import {Modal} from 'react-bootstrap'
import {ActionButton} from './ActionButton'
import * as yup from 'yup'

function getIcon(variant) {
  let icon = ''

  switch (variant) {
    case 'primary':
      icon = 'fa-solid fa-flag'
      break
    case 'warning':
      icon = 'fa-exclamation-triangle'
      break
    case 'danger':
      icon = 'fa-exclamation-triangle'
      break
    default:
      icon = 'fa-solid fa-flag'
  }

  return icon
}

const defaultSchema = yup.object().shape()

export const ActionModal = ({
  variant = 'primary',
  show,
  onHide,
  onSubmit = () => null,
  loading = false,
  title,
  message,
  initialValues = {},
  schema = defaultSchema,
  children,
}) => {
  function closeModal(callback) {
    onHide()

    if (callback instanceof Function) {
      callback()
    }
  }

  return (
    <Formik
      initialValues={{...initialValues}}
      onSubmit={(values) => {
        onSubmit(values)
      }}
      validationSchema={schema}
    >
      {({handleSubmit, resetForm}) => (
        <Modal
          size='md'
          show={show}
          centered
          onHide={onHide}
          aria-labelledby='example-modal-sizes-title-lg'
        >
          <Modal.Header closeButton>
            <Modal.Title id='example-modal-sizes-title-lg'>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{textAlign: 'center'}}>
              <i
                className={`fas ${getIcon(variant)} text-${variant}`}
                style={{fontSize: '64px'}}
              ></i>
            </div>
            <div className='mt-8 text-center'>
              <strong>{message}</strong>
            </div>
            <div className='my-3'>{children}</div>
          </Modal.Body>
          <Modal.Footer>
            <div className='d-flex align-items-center'>
              <ActionButton
                type='button'
                loading={loading}
                style={{width: '75px', height: '35.59px'}}
                className='btn btn-secondary btn-elevate mr-3'
                onClick={() => {
                  !loading && closeModal(resetForm)
                }}
                text='Batal'
              />
              <ActionButton
                type='button'
                loading={loading}
                style={{width: '75px', height: '35.59px'}}
                className='btn btn-primary btn-elevate'
                onClick={() => {
                  !loading && handleSubmit()
                }}
                text='Yakin'
              />
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  )
}
